"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUnreadNotificationList = exports.setSocketConnection = exports.setRemoveNotificationById = exports.setNotificationUnreadCheck = exports.setNotificationMarkAsRead = exports.setNotificationAllUnreadCheck = exports.setNewMessage = exports.setNewHeaderMessage = exports.setNewAnnouncement = exports.setHeaderList = exports.setAnnouncementList = exports.setAllNotificationList = void 0;

var _types = require("../types/types");

const setSocketConnection = payload => dispatch => {
  dispatch({
    type: _types.SET_SOCKET_CONNECTION,
    payload: payload
  });
};

exports.setSocketConnection = setSocketConnection;

const setNewMessage = payload => dispatch => {
  dispatch({
    type: _types.SET_NEW_MESSAGE,
    payload: payload
  });
};

exports.setNewMessage = setNewMessage;

const setNewAnnouncement = payload => dispatch => {
  dispatch({
    type: _types.SET_NEW_ANNOUNCEMENT,
    payload: payload
  });
};

exports.setNewAnnouncement = setNewAnnouncement;

const setAnnouncementList = payload => dispatch => {
  dispatch({
    type: _types.SET_ANNOUNCEMENT_LIST,
    payload: payload
  });
};

exports.setAnnouncementList = setAnnouncementList;

const setNewHeaderMessage = payload => dispatch => {
  dispatch({
    type: _types.SET_NEW_HEADER_MESSAGE,
    payload: payload
  });
};

exports.setNewHeaderMessage = setNewHeaderMessage;

const setHeaderList = payload => dispatch => {
  dispatch({
    type: _types.SET_HEADER_LIST,
    payload: payload
  });
};

exports.setHeaderList = setHeaderList;

const setAllNotificationList = payload => dispatch => {
  dispatch({
    type: _types.SET_NOTIFICATION_ALL_LIST,
    payload: payload
  });
};

exports.setAllNotificationList = setAllNotificationList;

const setUnreadNotificationList = payload => dispatch => {
  dispatch({
    type: _types.SET_NOTIFICATION_UNREAD_LIST,
    payload: payload
  });
};

exports.setUnreadNotificationList = setUnreadNotificationList;

const setNotificationAllUnreadCheck = payload => dispatch => {
  dispatch({
    type: _types.RESET_NOTIFICATION_ALL_LIST,
    payload: payload
  });
};

exports.setNotificationAllUnreadCheck = setNotificationAllUnreadCheck;

const setNotificationUnreadCheck = payload => dispatch => {
  dispatch({
    type: _types.RESET_NOTIFICATION_UNREAD_LIST,
    payload: payload
  });
};

exports.setNotificationUnreadCheck = setNotificationUnreadCheck;

const setNotificationMarkAsRead = payload => dispatch => {
  dispatch({
    type: _types.SET_MARK_AS_READ,
    payload: payload
  });
};

exports.setNotificationMarkAsRead = setNotificationMarkAsRead;

const setRemoveNotificationById = payload => dispatch => {
  dispatch({
    type: _types.SET_REMOVE_NOTIFICATION,
    payload: payload
  });
};

exports.setRemoveNotificationById = setRemoveNotificationById;